// Keep explicit theme-preview navigation in the same unpublished theme.
document.addEventListener('click', e => {
 const a=e.target.closest('a'); if(!a || a.target==='_blank' || a.hasAttribute('download')) return;
 const theme=new URLSearchParams(location.search).get('preview_theme_id');
 const u=new URL(a.href,location.href);
 if(theme && u.origin===location.origin && !u.pathname.startsWith('/checkout') && !u.pathname.startsWith('/policies/')) {u.searchParams.set('preview_theme_id',theme);a.href=u.href;}
});
